import React, { useEffect, useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { Panel, MonoLabel } from "@/components/Panel";
import { toast } from "sonner";
import { api, errText } from "@/lib/devadminApi";

/** Safety valve: turn phone/email OTP verification off if a provider goes down on event day. */
export function ContactVerification({ eventId }) {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setCfg(null);
    api.get(`/events/${eventId}/contact-verification`).then((r) => setCfg(r.data))
      .catch((e) => toast.error(errText(e)));
  }, [eventId]);

  const save = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.put(`/events/${eventId}/contact-verification`, next);
      setCfg(data);
      toast.success("Verification rules updated");
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  if (!cfg) return <div className="mono-label" data-testid="cv-loading">Loading verification rules…</div>;

  const Row = ({ k, title, hint }) => (
    <div className="flex items-start justify-between gap-4 hairline p-4">
      <div className="min-w-0">
        <div className="text-sm">{title}</div>
        <div className="mono-label mt-1" style={{ color: "var(--taupe)" }}>{hint}</div>
      </div>
      <button data-testid={`cv-toggle-${k}`} disabled={busy}
        className={cfg[k] ? "btn-red !py-2 !px-3 text-xs" : "btn-ghost !py-2 !px-3 text-xs"}
        onClick={() => save({ ...cfg, [k]: !cfg[k] })}>
        {busy ? <Loader2 size={13} className="animate-spin" /> : cfg[k] ? "Required" : "Off"}
      </button>
    </div>
  );

  return (
    <Panel className="p-6" data-testid="contact-verification-panel">
      <MonoLabel><ShieldCheck size={13} className="inline mr-2" />Contact verification</MonoLabel>
      <p className="text-sm mt-3" style={{ color: "var(--taupe)" }}>
        When required, a registration cannot be created until the guest has entered the 6-digit code
        we send them. Enforced on the server, so it can't be skipped from the browser. Switch a channel
        off only if that provider is down.
      </p>
      <div className="mt-5 space-y-3">
        <Row k="phone_required" title="WhatsApp number" hint="6-digit code sent on WhatsApp via AiSensy" />
        <Row k="email_required" title="Email address" hint="6-digit code emailed from bnidavangereregion@gmail.com" />
      </div>
    </Panel>
  );
}
